/*
  ol-apptipp - Beschriftung fuer die Programmsymbole auf den
  Kategoriekarten.

  Auf den Karten steht der Programmname nur im title-Attribut des
  Bildes. Ein <img> traegt keine Pseudoelemente, also kann CSS daraus
  keine gestaltete Sprechblase bauen. Dieses Skript kopiert den Namen
  einmalig auf das umschliessende <li> (data-ol-name); die Blase selbst
  liegt als CSS in blocks/ol-fakten.liquid, dessen {% stylesheet %}
  Shopify in die gebuendelte Theme-CSS schreibt.

  Ohne JavaScript passiert nichts Schlimmes: dann bleibt der normale
  Browser-Tooltip aus dem title-Attribut.

  Der title bleibt absichtlich stehen - er ist die Rueckfallebene und
  wird von Vorlesehilfen genutzt.
*/
(function () {
  'use strict';

  function beschriften() {
    document.querySelectorAll('.bsfa-kat__apps > li').forEach(function (li) {
      if (li.hasAttribute('data-ol-name')) return;
      var bild = li.querySelector('img[title], img[alt]');
      if (!bild) return;
      var name = (bild.getAttribute('title') || bild.getAttribute('alt') || '').trim();
      if (!name) return;
      li.setAttribute('data-ol-name', name);
      // Tastatur: ohne fokussierbares Element gaebe es die Blase nur
      // mit der Maus. tabindex="0" plus role/aria-label macht die
      // Reihe auch mit der Tastatur und fuer Vorlesehilfen lesbar.
      if (!li.hasAttribute('tabindex')) {
        li.setAttribute('tabindex', '0');
        li.setAttribute('role', 'img');
        li.setAttribute('aria-label', name);
      }
    });
  }

  var geplant = false;
  function spaeter() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () { geplant = false; beschriften(); });
  }

  if (document.readyState !== 'loading') beschriften();
  else document.addEventListener('DOMContentLoaded', beschriften, { passive: true });

  // Canyon rendert Listen beim Filtern und Blaettern neu.
  new MutationObserver(spaeter).observe(document.documentElement, { childList: true, subtree: true });
})();
